import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { ProductDetailSpecification } from './ProductDetailSpecification.js';
import { getCategorySpecificationListItems } from './utils/get-category-specification-list-items.js';
import { getConfigurationSpecificationItems } from './utils/get-configuration-specification-items.js';

const ProductDetailSpecificationContainer = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { product: { commercialCategories  } , activeVariant: { specifications  } , specificationConfiguration ,  } = useProductData();
    const items = [
        ...getConfigurationSpecificationItems(specificationConfiguration, specifications, getLabel),
        ...getCategorySpecificationListItems(commercialCategories), 
    ];
    if (!items.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        className: className,
        items: items
    });
};

export { ProductDetailSpecificationContainer };
//# sourceMappingURL=ProductDetailSpecificationContainer.js.map
